(function () {
	angular
		.module('trackeye')
		.factory('LogService', _LogServiceFactory);

	_LogServiceFactory.$inject = ['Logger', 'NotificationService', 'C4ApiService', 'ResponseXHR', '$location'];

	function _LogServiceFactory(Logger, NotificationService, api, ResponseXHR, $location) {
		var exports = {},
			handlers = [],
			account = "N/A";

		exports.setAccount = function (name) {
			account = name;
		};

		/**
		 *
		 * @param {string} name
		 * @param {function} [callback]
		 * @returns {function}
		 */
		exports.handle = function (name, callback) {
			var logger = new Logger(name, callback);

			if (!logger.isResolved())
				return exports._noop();

			return (function (data, dispatch_log) {
				var handle = logger.exec(data);

				NotificationService.byLogHandle(handle);

				if (logger.hasCallback())
					logger.execCallback(data);

				if (dispatch_log === true) {
					dispatch(data);
				}
			});
		};

		exports._noop = function () {
			return angular.noop;
		};

		function dispatch(handle) {
			var log = {
				type: handle.getLevel(),
				account: account,
				url: $location.$$path,
				message_id: handle.getMessageId(),
				message: handle.getMessage(),
				data: handle.getData()
			};

			var xhr = handle.getXhr();
			if (xhr instanceof ResponseXHR) {
				angular.extend(log, {status: xhr.getStatus(), responseData: xhr.getResponseData()});
			}

			api.dispatchLog(log);
			return log;
		}

		return exports;
	}
}());